import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export default styled(Typography)`
	// Add your styles here
`;

const TextCode = styled(Text)`
	color: ${({ colorTextPlaceholder }) => `${colorTextPlaceholder}`};
	font-size: ${({ fontSizeSM }) => `${fontSizeSM}px`};
	code {
		padding-inline: 0 !important;
		padding-block: 0 !important;
		padding: 4px !important;
		border-radius: 4px;
	}
`;

export { TextCode };
